import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowRight, Check, ArrowLeft } from "lucide-react";
import { products } from "../mock/mock";

const ProductDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const product = products.find((p) => p.slug === slug);
  const related = products.filter((p) => p.slug !== slug).slice(0, 4);

  if (!product) {
    return (
      <div className="max-w-[900px] mx-auto px-5 py-24 text-center">
        <h1 className="font-heading text-3xl font-semibold">Product not found</h1>
        <Link to="/" className="text-[#D80000] mt-4 inline-block">Back to home</Link>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="relative bg-[#141414]">
        <img src={product.image} alt={product.title} className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative max-w-[1140px] mx-auto px-5 py-20">
          <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-5">
            <ArrowLeft className="w-4 h-4" /> Back
          </button>
          <p className="text-[#D80000] font-heading font-semibold tracking-widest text-sm">PRODUCTS WE MANUFACTURE</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mt-3">{product.title}</h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20">
        <div className="max-w-[1140px] mx-auto px-5 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <img src={product.image} alt={product.title} className="rounded-lg shadow-xl w-full h-[380px] object-cover" />
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-[#1a1a1a]">{product.short}</h2>
            <p className="text-[#1a1a1a]/80 leading-8 mt-4">{product.description}</p>
            <h3 className="font-heading font-semibold text-[#1a1a1a] mt-8 mb-3">Capabilities</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {product.features.map((f) => (
                <li key={f} className="flex items-center gap-3 text-[#1a1a1a]">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#D80000]/10 shrink-0">
                    <Check className="w-4 h-4 text-[#D80000]" />
                  </span>
                  {f}
                </li>
              ))}
            </ul>
            <Link to="/contact" className="inline-flex items-center gap-2 mt-9 bg-[#D80000] text-white font-semibold px-7 py-3.5 rounded-md hover:bg-[#b00000]">
              Request a Quote <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Related */}
      <section className="bg-[#f7f7f8] py-16">
        <div className="max-w-[1140px] mx-auto px-5">
          <h2 className="font-heading text-2xl font-semibold text-[#1a1a1a] mb-8">Other Products We Manufacture</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {related.map((r) => (
              <Link key={r.slug} to={`/products/${r.slug}`} className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow">
                <div className="h-36 overflow-hidden">
                  <img src={r.image} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <p className="font-heading font-semibold text-[#1a1a1a] group-hover:text-[#D80000] text-sm">{r.title}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetail;
